import styled from "styled-components";

export const StartCardContainer = styled.div`
  height: 100%;
  background-color: #001b48;
  color: #fff;
  padding: 6.25rem 1.25rem 4.375rem 1.25rem;
  text-align: center;
  position: relative;

  & div {
    height: 3.75rem;
    width: 3.75rem;
    padding: 1.25rem;
    background-color: #004581;
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
  }

  @media(max-width:1330px){
    padding: 5.25rem 1.25rem 3.375rem 1.25rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    & p {
      max-width: 470px;
    }
  }
  @media(max-width:999px){
     padding: 1.25rem 1.25rem 1.25rem 1.25rem;
     min-height: 8.313rem;
     justify-content: left;

     & div{
      position: static;
     }
     & p{
      text-align: left;
      margin-left: 1.25rem;
     }
  }
  
`;
